export const iconFontAwesomeHumanitarianShirt = (
	<i className="fa-solid fa-shirt"></i>
);
